import { render } from "./PostCarpoolStep2.view.vue?vue&type=template&id=586b534f"
import script from "./PostCarpoolStep2.view.vue?vue&type=script&lang=js"
export * from "./PostCarpoolStep2.view.vue?vue&type=script&lang=js"

import "./PostCarpoolStep2.view.vue?vue&type=style&index=0&id=586b534f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__